<template>
  <layout title="Impressum" :banner="$page.props.banner" h1="Impressum">
    <section id="impressum-content">
      <div class="scol-section bg-light">
        <div class="container">
          <h2 class="text-secondary text-center">Angaben gemäß § 5 TMG:</h2>
          <div class="row mt-5">
            <div class="col-md-6">
              <h3>SCOL Tours</h3>
              <p>
                GmbH Hauptstraße 59<br />
                26197 Großenkneten
              </p>
              <br />
              <h3>Vertreten durch:</h3>
              <p>Herrn Ralf Kempermann e. K.</p>
              <br />
              <h3>Kontakt</h3>
              <p>Telefon: <a href="tel:+49443596000">+49 (0) 4435 96000</a></p>
              <p>Telefax: +49 (0) 4435 960013</p>
              <p>E-Mail: <a href="mailto:info@scol.de">info@scol.de</a></p>
              <br />
              <h3>Registereintrag</h3>
              <p>Eintragung im Handelsregister.</p>
              <p>Registergericht: Amtsgericht Oldenburg</p>
              <p>Registernummer: 141065</p>
              <br />
              <h3>Umsatzsteuer-ID</h3>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß §27 a
                Umsatzsteuergesetz:<br />DE 172229195
              </p>
              <br />
              <h3>Aufsichtsbehörde</h3>
              <p>Amtsgericht Oldenburg</p>
              <br />
              <h3>Quellenangaben für die verwendeten Bilder und Grafiken:</h3>
              <ul class="list-primary">
                <li>Nationalpark Gemeinde Kals am Großglockner</li>
                <li>Bergbahnen Kals am Großglockner GmbH und Co. KG</li>
                <li>Zillertal Tourismus GmbH (Fotografen: Andre Schönherr, Bernd Ritschel)</li>
                <li>TVB Erste Ferienregion im Zillertal</li>
                <li>TVB Paznaun-Ischgl</li>
                <li>Serfaus-Fiss-Ladis Marketing GmbH (hier: <a href="https://www.artinaction.de" target="_blank">www.artinaction.de</a>, Sepp Mallaun)</li>
                <li>TVB Mayrhofen-Hippach</li>
                <li>Alta Badia Brand (Fotografen: Freddy Planinschek, Stefanie Irsara, Andre Schönherr, Visual Working)</li>
                <li>TVB Fassatal</li>
                <li>Lenzerheide Marketing und Support AG</li>
                <li>Zell am See-Kaprun Tourismus GmbH</li>
                <li>Region Kitzbüheler Alpen & Tourismus</li>
                <li>KitzSki: Michael Werlberger</li>
                <li>St. Anton am Arlberg: © TVB St. Anton am Arlberg (Fotograf: Patrick Bätz)</li>
                <li>Ötztal Tourismus (Fotografen: Christoph Nösig, Tobias Siegele, Jochen Müller, Nicolai Semrau, Ernst Lorenzi)</li>
                <li>Gasteinertal Tourismus GmbH (Fotograf: Christoph Oberschneider)</li>
                <li>GASTI Park Angertal: © maxsteinbauer.com</li>
                <li>Gasteiner Perchten: © Florian Bachmeier</li>
                <li>Montequarium: © Alpentherme Gastein</li>
                <li>Weiteres Bildmaterial zur Verfügung gestellt von: Arriba Sportreisen GmbH, Team3Reisen, <a href="https://www.shutterstock.com" target="_blank">www.shutterstock.com</a></li>
                <li>Bilder der Hotels Urlaubsziele Kühtai und Nauders: Eurotours GmbH</li>
                <li>Bilder Ort/Landschaft Urlaubsziel Nauders: TVB Tiroler Oberland | Nauders (Fotografen: Daniel Zangerl, Florian Albert, Manuel Baldauf, Martin Lugger)</li>
                <li>Bilder Ort/Landschaft Urlaubsziel Kühtai: © Innsbruck Tourismus / Christian Vorhofer & Daniel Zangerl</li>
              </ul>
              <br />
              <h3>Hotel-Direktverlinkungen:</h3>
              <ul class="list-primary">
                <li>Peoples Hotel (Kaprun): <a target="_blank" href="https://peopleshotel.at">peopleshotel.at</a></li>
                <li>Pension Bergheil (Kaprun): <a target="_blank" href="https://pension-bergheil.at">pension-bergheil.at</a></li>
                <li>Hotel Alpenruh (Serfaus): <a target="_blank" href="https://micheluzzihotels.at">micheluzzihotels.at</a></li>
                <li>Hotel Amadeus (Serfaus): <a target="_blank" href="https://amadeus-serfaus.at">amadeus-serfaus.at</a></li>
                <li>Hotel Karl Schranz (St. Anton): <a target="_blank" href="https://hotelkarlschranz.com">hotelkarlschranz.com</a></li>
                <li>Hotel Waldcafe (Sölden): <a target="_blank" href="https://hotel-waldcafe.com">hotel-waldcafe.com</a></li>
                <li>Hotel Palace (Bad Hofgastein): <a target="_blank" href="https://hotel-palace.at">hotel-palace.at</a></li>
              </ul>
              <br />
              <p>
                Quelle:
                <a href="https://www.e-recht24.de/" target="_blank"
                  >https://www.e-recht24.de/</a
                >
              </p>
            </div>
            <div class="col-md-6">
              <h3>Haftungsausschluss (Disclaimer)</h3>
              <h4>Haftung für Inhalte</h4>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
                hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
                ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen
                werden wir diese Inhalte umgehend entfernen.
              </p>
              <br />
              <h4>Haftung für Links</h4>
              <p>
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar. Eine permanente inhaltliche
                Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
                Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                umgehend entfernen.
              </p>
              <br />
              <h4>Urheberrecht</h4>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten,
                nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
                dieser Seite nicht vom Betreiber erstellt wurden, werden die
                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
                Dritter als solche gekennzeichnet. Solltest Du trotzdem auf eine
                Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
                werden wir derartige Inhalte umgehend entfernen.
              </p>
              <br />
              <p>
                Quellen:
                <a
                  href="https://www.e-recht24.de/muster-disclaimer.html"
                  target="_blank"
                  >Disclaimer eRecht24,</a
                >,
                <a
                  href="https://www.e-recht24.de/muster-disclaimer.html"
                  target="_blank"
                  >eRecht24 Disclaimer</a
                >
              </p>
              <br />
              <h3 class="mb-3">Layout, Umsetzung und Betreuung:</h3>
              <a href="https://www.emotivo.de/" target="_blank">
                <img
                  src="/images/emotivo-logo.svg"
                  alt="eMotivo GmbH Logo"
                  width="200"
                />
              </a>
              <p class="mt-2">
                eMotivo GmbH
                <br />
                Thüler Straße 10
                <br />
                26219 Bösel
                <br />
                <a href="https://www.emotivo.de/" target="_blank">
                  www.emotivo.de
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 3,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
    },
  }),
};
</script>
